import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ConsultingHero = () => {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[75vh] flex items-center justify-center overflow-hidden bg-[#050008] pt-20">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0d0020] via-[#050008] to-[#000d1a]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_40%,rgba(140,82,255,0.15)_0%,transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_60%,rgba(0,194,255,0.10)_0%,transparent_60%)]" />
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: 'linear-gradient(rgba(140,82,255,0.8) 1px, transparent 1px), linear-gradient(90deg, rgba(140,82,255,0.8) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20business%20consulting%20meeting%20boardroom%20dark%20elegant%20atmosphere%20two%20entrepreneurs%20discussing%20strategy%20documents%20laptop%20modern%20office%20neon%20ambient%20lighting%20sophisticated%20corporate%20environment&width=1600&height=900&seq=bchero1&orientation=landscape"
          alt="Business Consulting"
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050008]/60 via-[#050008]/40 to-[#050008]/90" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 text-center py-20">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/5 border border-[#8c52ff]/30 rounded-full px-4 py-2 mb-7">
          <i className="ri-briefcase-4-line text-[#8c52ff] text-sm" />
          <span className="text-[#8c52ff] text-xs font-bold uppercase tracking-widest">{t('consulting.hero.badge')}</span>
        </div>

        {/* H1 */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
          {t('consulting.hero.titlePrefix')}<br />
          <span className="bg-gradient-to-r from-[#8c52ff] via-[#00c2ff] to-[#FF2DAA] bg-clip-text text-transparent">
            {t('consulting.hero.titleHighlight')}
          </span>
        </h1>

        <p className="text-white/55 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-10">
          {t('consulting.hero.subtitle')}
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-14">
          <Link
            to="/contact"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#8c52ff] to-[#00c2ff] text-white font-bold px-8 py-4 rounded-full hover:opacity-90 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-calendar-line" />
            {t('consulting.hero.cta.book')}
          </Link>
          <a
            href="#services"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 bg-white/5 border border-white/20 text-white font-semibold px-8 py-4 rounded-full hover:bg-white/10 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-down-line" />
            {t('consulting.hero.cta.explore')}
          </a>
        </div>

        {/* Stats */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-14">
          {[
            { value: 'LLC', label: t('consulting.hero.stats.llc') },
            { value: '100%', label: t('consulting.hero.stats.guidance') },
            { value: 'Setup', label: t('consulting.hero.stats.setup') },
          ].map((s, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-black bg-gradient-to-r from-[#8c52ff] to-[#00c2ff] bg-clip-text text-transparent">
                {s.value}
              </div>
              <div className="text-white/40 text-xs uppercase tracking-wider mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConsultingHero;
